import React, { Component } from 'react';
import {withRouter, Link} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import * as tgCdes from "../consts/widetcodes";

class TGWidget extends Component {

  constructor(props) {
    super(props);
    this.state = {
      Channel: ""
    };
  }

  getKey(isButton) {
    let pKey = this.props.WidgetKey;
    if(wActs.isNullOrUndefined(pKey)) {
      console.error("Missing Key For TGWidget...");
      return "";
    }
    if(isButton) {
      pKey += "Info";
    } else {
      pKey += "Chat";
    }
    return pKey;
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  getChat(key) {
    switch(key.toLowerCase()) {
      case "enholland": {  return tgCdes.EnHollandChat;}
      case "enathens": {  return tgCdes.EnAthensChat;}
      case "encyprus": {  return tgCdes.EnCyprusChat;}
      case "enthessa": {  return tgCdes.EnThessaChat;}
      case "enuk": {  return tgCdes.EnUKChat;}
      case "enrussia": {  return tgCdes.EnRussiaChat;}
      case "enitaly": {  return tgCdes.EnItalyChat;}
      case "enbelgium": {  return tgCdes.EnBelgiumChat;}
      case "enturkey": {  return tgCdes.EnTurkeyChat;}
      case "enmalta": {  return tgCdes.EnMaltaChat;}
      case "enasia": { return tgCdes.EnAsiaChat}
      case "enmiddleeast": { return tgCdes.EnMiddleEastChat}
    }
  }
  getInfo(key) {
    switch(key.toLowerCase()) {
      case "enholland": {  return tgCdes.EnHollandInfo;}
      case "enturkey": {  return tgCdes.EnTurkeyInfo;}
      case "enathens": {  return tgCdes.EnAthensInfo;}
      case "encyprus": {  return tgCdes.EnCyprusInfo;}
      case "enuk": {  return tgCdes.EnUKInfo;}
      case "enthessa": {  return tgCdes.EnThessaInfo;}
      case "enrussia": {  return tgCdes.EnRussiaInfo;}
      case "enitaly": {  return tgCdes.EnItalyInfo;}
      case "enbelgium": {  return tgCdes.EnBelgiumInfo;}
      case "enmalta": {  return tgCdes.EnMaltaInfo;}
      case "enasia": { return tgCdes.EnAsiaInfo}
      case "enmiddleeast": { return tgCdes.EnMiddleEastInfo}

    }
  }
  getButton(key) {
    switch(key.toLowerCase()) {
      case "enholland": {  return tgCdes.EnHollandButton;}
      case "enturkey": {  return tgCdes.EnTurkeyButton;}
      case "enathens": {  return tgCdes.EnAthensButton;}
      case "encyprus": {  return tgCdes.EnCyprusButton;}
      case "enthessa": {  return tgCdes.EnThessaButton;}
      case "enuk": {  return tgCdes.EnUKButton;}
      case "enrussia": {  return tgCdes.EnRussiaButton;}
      case "enitaly": {  return tgCdes.EnItalyButton;}
      case "enbelgium": {  return tgCdes.EnBelgiumButton;}
      case "enmalta": {  return tgCdes.EnMaltaButton;}
      case "enasia": { return tgCdes.EnAsiaButton}
      case "enmiddleeast": { return tgCdes.EnMiddleEastButton}
    }
  }

  render() {
    if(!this.props.WebPage.PageLoaded) {return null;}
    return (<div>
      <div className="widget-info-holder" ref={(r) => {this.Info = r}}></div>
      <div className="clear"></div>
      <div className="widget-button-holder" ref={(r) => {this.Button = r}}></div>
      <div className="clear"></div>
      <div className="widget-holder" ref={(r) => { this.Widget = r }}></div>
    </div>);
  }


  componentDidUpdate(pProps,pState) {
    if((this.state.Channel !== this.props.WidgetKey) || (this.Widget && !this.Widget.hasChildNodes())) {
      console.log(this.props.WidgetKey);
      if (this.Widget) {
        const range = document.createRange();
        this.Widget.innerHTML = "";
        this.Widget.appendChild(range.createContextualFragment(this.getChat(this.props.WidgetKey).replace("540px",this.props.ChatHeight ? this.props.ChatHeight : "1700px" )));
      }
      if (this.Button) {
        const range = document.createRange();
        this.Button.innerHTML = "";
        this.Button.appendChild(range.createContextualFragment(this.getButton(this.props.WidgetKey)));
      }
      if (this.Info) {
        const range = document.createRange();
        this.Info.innerHTML = "";
        this.Info.appendChild(range.createContextualFragment(this.getInfo(this.props.WidgetKey)));
      }
      this.setState({Channel: this.props.WidgetKey});
    } else {
      console.log(`Childs: ${this.Widget ? this.Widget.childNodes : ""}`);
    }
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    HtmlSections: state.Website.Settings.HtmlSections,
  };
};

export default connect(mapStateToProps)(TGWidget);
